import { createSlice } from '@reduxjs/toolkit';

import extraReducers from './extraReducers';
import initialState from './initialState';

const connectionsSlice = createSlice({
    name: 'connections',
    initialState,
    reducers: {},
    extraReducers,
});

export default connectionsSlice.reducer;
